import { StepName } from "../models/stepper";

const NORMAL_STEPS: StepName[] = ["Kies type", "Documenten toevoegen"];
const DOSSIER_STEPS: StepName[] = ["Kies type", "Dossier maken", "Documenten toevoegen"];
const DEFAULT_STEPS: StepName[] = ["Kies type", "Vervolg"];

export const StepperConfig = (state: any): StepName[] => {
  switch (state.stepper.flow) {
    case "Normal":
      return NORMAL_STEPS;
    case "Dossier":
      return DOSSIER_STEPS;
    default:
      return DEFAULT_STEPS;
  }
};
